var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$root.userLoggedIn)?_c('modal',{attrs:{"title":"Explore Zight Features","id":"prize-steps-modal","data-testid":"prize_steps_modal","hide-footer":true},on:{"shown":function($event){return _vm.track('viewed_prize_steps')}}},[_c('iframe',{staticClass:"resp-iframe",attrs:{"src":_vm.iframeUrl,"frameborder":"0","allowfullscreen":""}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }